module.exports = __webpack_public_path__ + "img/339.609b208.png";